import { useDispatch, useSelector } from 'react-redux';
import { resetFilters, selectAuthorFilter, selectOnlyFavoriteFilter, selectTitleFilter, setAuthorFilter, setOnlyFavoriteFilter, setTitleFilter } from '../../redux/slices/filterSlice';
import './Filter.css';

const FIlter = () => {
  const dispatch = useDispatch()
  const titleFilter = useSelector(selectTitleFilter);
  const authorFilter = useSelector(selectAuthorFilter);
  const onlyFavoriteFilter = useSelector(selectOnlyFavoriteFilter);

  const handleTitleFilterChange = (text) => {
    dispatch(setTitleFilter(text))
  }

  const handleAuthorFilterChange = (text) => {
    dispatch(setAuthorFilter(text))
  }

  const handleOnlyFavoriteFilterChange = () => {
    dispatch(setOnlyFavoriteFilter())
  }

  const handleResetFilters = () => {
    dispatch(resetFilters());
  }

  return (
    <div className="app-block filter">
      <div className="filter-row">
        <div className="filter-group">
          <input
            value={titleFilter}
            onChange={(e) => handleTitleFilterChange(e.target.value)}
            type="text"
            placeholder="Filter by title..."
          />
        </div>
        <div className="filter-group">
          <input
            value={authorFilter}
            onChange={(e) => handleAuthorFilterChange(e.target.value)}
            type="text"
            placeholder="Filter by author..."
          />
        </div>
        <div className='filter-group'>
          <label>
            <input type='checkbox' checked={onlyFavoriteFilter} onChange={handleOnlyFavoriteFilterChange} />
            Only Favorite
          </label>

        </div>
        <button type="button" onClick={handleResetFilters}>
          Reset filters
        </button>
      </div>
    </div>
  );
};

export default FIlter;
